import { EXPRESSION_LANE_BAR_HEIGHT, EXPRESSION_LANE_GAP } from "@/settings/settings.js";

import {
  type CallTooltip,
  type IConditionNameLookup,
} from "../../ui-modules/genome-viewer/features-track/FeatureTrack.js";
import { type IExpressionOverlayTooltipData, TRACK_TOOLTIP_TYPE } from "./shape-feature.js";
import { type IPileupFeature, type IPileupParams } from "./track-pileup-factory.js";
import {
  ArrowDirection,
  type GenomeViewerShape,
  type GenomeViewerShapeInteractivity,
  type getShapeRenderer,
} from "./track-shapes-konva-renderers.js";

interface IExpressionOverlayShapeParams {
  feature: IPileupFeature;
  referenceShapeYPosition: number;
  pileupParams: IPileupParams;
  expressionColoringConditionNameLookup: IConditionNameLookup;
  renderArrow: ReturnType<typeof getShapeRenderer>["renderArrow"];
  callTooltip: CallTooltip;
}

const createExpressionOverlayShapes = ({
  referenceShapeYPosition,
  feature,
  pileupParams,
  renderArrow,
  callTooltip,
  expressionColoringConditionNameLookup,
}: IExpressionOverlayShapeParams) => {
  feature.expressionParams.forEach((expressionParam, index) => {
    const expShape: GenomeViewerShape = renderArrow({
      start: feature.feature.region?.range.start, // feature.x
      stop: feature.feature.region?.range.stop, // feature.x + feature.width
      direction: ArrowDirection.None,
      fill: expressionParam.expressionColor || "#FFFFFF",
      hasStroke: true,
      y:
        referenceShapeYPosition +
        pileupParams.featureHeight +
        EXPRESSION_LANE_GAP +
        index * (EXPRESSION_LANE_GAP + EXPRESSION_LANE_BAR_HEIGHT),
      height: EXPRESSION_LANE_BAR_HEIGHT,
      inclusiveStartPosition: true,
    });

    const shapeInteractivity: GenomeViewerShapeInteractivity = expShape.interactive();

    callTooltip(shapeInteractivity.interactiveShape, shapeInteractivity.tooltipTargetShape, {
      uid: `${feature.feature.type}-${feature.feature.id}-${expressionParam.condition}`,
      title: feature.feature.name,
      type: TRACK_TOOLTIP_TYPE.EXPRESSION_OVERLAY,
      content: {
        expression: expressionParam,
        expressionColoringConditionNameLookup,
      } as IExpressionOverlayTooltipData,
    });
  });
};

export { createExpressionOverlayShapes };
